import classNames from 'classnames'
import type { FC } from 'react'
import React, { useEffect, useRef } from 'react'

import debounce from '../../utils/debounce'

const styles: React.CSSProperties = {
  width: 99,
  height: 99,
  position: 'absolute',
  top: -9999,
  overflow: 'scroll'
}

const ScrollbarSizeListener: FC<{
  className?: string
  onChange: (size?: { height: number; width: number }) => void
}> = props => {
  const { className, onChange, ...other } = props
  const scrollbarSize = useRef<{
    height: number
    width: number
  }>()
  const nodeRef = useRef<HTMLDivElement>(null)

  const setMeasurements = () => {
    scrollbarSize.current = nodeRef.current
      ? {
          height: nodeRef.current.offsetHeight - nodeRef.current.clientHeight,
          width: nodeRef.current.offsetWidth - nodeRef.current.clientWidth
        }
      : undefined
  }

  useEffect(() => {
    const handleResize = debounce(() => {
      const prevHeight = scrollbarSize.current
      setMeasurements()

      if (prevHeight !== scrollbarSize.current) {
        onChange(scrollbarSize.current)
      }
    })

    window.addEventListener('resize', handleResize)
    return () => {
      handleResize.clear()
      window.removeEventListener('resize', handleResize)
    }
  }, [onChange])

  useEffect(() => {
    setMeasurements()
    onChange(scrollbarSize.current)
  }, [onChange])

  return (
    <div
      className={classNames(
        {
          'csg-tui-scrollbar-size-listener': true
        },
        className
      )}
      style={styles}
      ref={nodeRef}
      {...other}
    />
  )
}

export default ScrollbarSizeListener
